module.exports = __webpack_public_path__ + "static/img/yx-wuzhong.6dee354.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yx-wuzhong.png
// module id = XPIl
// module chunks = 0